import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiError, LoadContactPage, LoadContactPageSuccess, ProcessContactFormError, ProcessedContactForm, SubmitContactForm } from '../actions';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { CmsService } from '../../services/cms.service';
import { selectLanguage } from '../selectors';
import { ContactState } from './contact.reducer';
import { PageBase } from '../../models';

@Injectable()
export class ContactEffects {
  private actions$ = inject(Actions);
  private cms = inject(CmsService);
  private store = inject(Store);


  onLoadContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadContactPage),
      withLatestFrom(this.store.pipe(select(selectLanguage))),
      switchMap(([action, language]) => this.cms.getOrphan<ContactState & PageBase>(language, 'contact')
        .pipe(
          map((page) => LoadContactPageSuccess({ page })),
          catchError((error) => of(ApiError({ error })))
        )),
    ),
  );

  onSubmitContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SubmitContactForm),
      switchMap(({ formData }) =>
        this.cms.postContactForm(formData).pipe(
          map(() => ProcessedContactForm()),
          catchError((error) => of(ProcessContactFormError({ error }))),
        ),
      ),
    ),
  );
}
